var DisconnectGrouper = function (options) {
    this.buffer = options.buffer;
    this.lines = [options.line];
    this.rows = options.rows;
    this.formatter = options.formatter;
    this.index = options.index;
    this.spliceCount = this.rows.length;
    this.sentences = '';
    this.expanded = false;
};
DisconnectGrouper.prototype = {
    setIndex: function (index) {
        this.index = index;
    },
    getFirstLine: function () {
        return this.lines[0];
    },
    addMessage: function (line, rows) {
        if (line.get('match')) {
            this.expanded = true;
        }
        this.lines.push(line);
        this.rows.push.apply(this.rows, rows);
        // Return whether this is the first grouping we've done
        var isFirst = (this.lines.length == 2);
        if (!isFirst) {
            this.spliceCount = 3;
        }
        return isFirst;
    },
    renderMessage: function (line, rows) {
        var isFirst = this.addMessage(line, rows);
        this.render();
        return isFirst;
    },
    render: function () {
        var messages = [];
        var messageCounts = {};
        _.each(this.lines, function (line) {
            var discoMessage = line.getDisconnectMessage();
            if (discoMessage) {
                var msg = this.formatter.renderLinkify(discoMessage);
                if (!messageCounts[msg]) {
                    messageCounts[msg] = 0;
                }
                messageCounts[msg]++;
                if (!_.contains(messages, msg)) {
                    messages.push(msg);
                }
            }
        }, this);
        messages = _.map(messages, function (msg) {
            if (messageCounts[msg] > 1) {
                msg += ' (x' + messageCounts[msg] + ')';
            }
            return msg;
        });
        this.sentences = '<span class="sentence">' + messages.join(', ') + '</span>';
        return this;
    }
};


module.exports = DisconnectGrouper;



//////////////////
// WEBPACK FOOTER
// ./app/src/format/disconnectgrouper.js
// module id = udet
// module chunks = 1